// Frontend configuration (build-time env). The PWA talks only to the Shake
// backend; VIO is reached through it, so no VIO URL lives in this bundle.

const config = {
  // API base URL for our backend
  apiBaseUrl: process.env.REACT_APP_API_URL || '/api',
};

export default config;
